import { localizeWithPath } from '../../../../nls.js';
import { CHAT_PROVIDER_ID } from '../common/chatParticipantContribTypes.js';
const _moduleId = "vs/workbench/contrib/chat/browser/chat";
async function showChatView(viewsService) {
    return (await viewsService.openView(CHAT_VIEW_ID))?.widget;
}
const GeneratingPhrase = ( localizeWithPath(_moduleId, 0, "Generating"));
const CHAT_VIEW_ID = `workbench.panel.chat.view.${CHAT_PROVIDER_ID}`;
export { CHAT_VIEW_ID, GeneratingPhrase, showChatView };
